export default __webpack_public_path__ + "assets/images/8cd1303741b93a9ca7095e7522224248.png";